import { Component, Input } from '@angular/core';

@Component({
	selector: 'ws-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
	@Input() diameter: number = 20;
	@Input() strokeWidth?: number;
	@Input() label?: string;
}
